// extracted by mini-css-extract-plugin
export default {"container":"Oo-z","blurb":"Po-z","links":"Qo-z"};